(function() {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('ObservationDefinitions', ObservationDefinitions);

    ObservationDefinitions.$inject = ['$http', 'FileUploadService', '$uibModal'];
    function ObservationDefinitions ($http, FileUploadService, $uibModal) {
        return {
            getObservationDefinitions:getObservationDefinitions,
            getObservationDefinition:getObservationDefinition,
            uploadObservationDefinition: uploadObservationDefinition,
            openDeleteDialog : openDeleteDialog,
            confirmDelete: confirmDelete,
            loadNexusVersions: loadNexusVersions,
            importVersionsFromNexus: importVersionsFromNexus
        };

        function getObservationDefinitions(success, failure, operational) {
            var url = 'api/observation-definitions/';
            if (operational) {
                url += '?operational=true';
            }
            $http({
                method: 'GET',
                url: url
            }).then(success, failure);
        }

        function getObservationDefinition(label, success, failure) {
            $http({
                method: 'GET',
                url: 'api/observation-definitions/' + label
            }).then(success, failure);

        }

        function uploadObservationDefinition(label, files, description, success, failure) {
            FileUploadService.uploadFiles(files, 'api/observation-definitions/multi-files-upload', label, success,
                failure,
                FileUploadService.progressCallback,
                description);
        }

        function openDeleteDialog(label) {
            $uibModal.open({
                templateUrl: 'app/entities/observation-definitions/observation-definitions-delete-dialog.html',
                controller: 'ObservationDefinitionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label
                    }
                }
            });
        }

        function confirmDelete(label, success, failure) {
            $http({
                method: 'DELETE',
                url: 'api/observation-definitions/' + label
            }).then(success, failure);
        }

        function loadNexusVersions(success, failure) {
            $http({
                method: 'GET',
                url: 'api/observation-definitions/nexus'
            }).then(success, failure);
        }

        function importVersionsFromNexus(versionsToImport, success, failure) {
            $http({
                method: 'POST',
                url: 'api/observation-definitions/nexus',
                params: {
                    "versions" : versionsToImport
                }
            }).then(success, failure);
        }
        function loadObsDefinitionsLabels(success, failure, operational) {
            var url = 'api/observation-definitions/labels';
            if (operational) {
                url += '?operational=true'
            }
            $http({
                method: 'GET',
                url: url
            }).then(success, failure);
        }


    }
})();
